<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
    depressed
    :class="['button', size, type]"
    :style="{
      backgroundColor: disabled ? '#ACABAB !important' : undefined,
      color: disabled ? '#fff !important' : undefined,
    }">
    <slot />
  </v-btn>
</template>

<script>

export default {
  name: 'Button',
  props: {
    size: String,
    disabled: {
      default: false,
      type: Boolean
    },
    type: {
      default: 'primary',
      type: String
    }
  }
}

</script>

<style lang="scss" scoped>
  .button {
    min-height: 34px;
    border-radius: 20px;
    background-color: var(--v-primary-base);
    box-shadow: 0px 4px 16px rgba(22, 22, 22, 0.14);
    text-transform: none;
    color: #fff !important;
  }

  .xx-small {
    min-width: 115px !important;
  }

  .x-small {
    min-width: 145px !important;
  }
  .small {
    min-width: 165px !important;
  }
  .regular {
    min-width: 185px !important;
  }
  .large {
    min-width: 215px !important;
  }
  .x-large {
    min-width: 240px !important;
  }
  .fullWidth {
    width: 100%;
  }

  .outlined {
    border: 2px solid var(--v-primary-base) !important;
    background-color: #fff !important;
    box-sizing: border-box;
    border-radius: 20px;
    color: #646464 !important;
  }

</style>
